import { Box, Typography } from "@mui/material";
import CriSection from "../../components/CriSection";

const OverviewSection = () => {
  return (
    <CriSection>
      <Box>
        <Typography
          sx={{
            fontSize: "36px",
            fontWeight: 300,
          }}
        >
          RESEARCH AT THE CONSERVATION RESEARCH INSTITUTE
        </Typography>

        <Typography
          sx={{
            fontWeight: 300,
            fontSize: "16px",
            lineHeight: 1.2,
            marginTop: "12px",
            marginBottom: "16px",
          }}
        >
          All of the research interests of scientists who are affiliated with
          the Conservation Research Institute are geared to the identification,
          understanding, and management of irreplaceable natural remnants. Our
          focus arises from the recognition that only through the advancing of
          the of knowledge of organisms are we able to contribute to these
          goals. Ecological theories rise, fall, or become modified regularly;
          environmental resource agencies are governed by the knowledge of their
          agents, all of whom are subject to hierarchical, political and
          budgetary influences.
        </Typography>

        <Typography
          sx={{
            fontWeight: 300,
            fontSize: "16px",
            lineHeight: 1.2,
            marginBottom: "16px",
          }}
        >
          It is the organisms themselves, whose very lives and life cycles, are
          born of natural systems and provide consistent information with regard
          to our understanding of them and their habitats. The organisms are not
          tenure-tracked, ego-driven, indoctrinated to contemporary political or
          cultural theory, subject to cupidity, or compelled to mendacity. The
          world’s organisms either prosper with fecund populations in the slow
          but inexorable changes that occur on earth or they languish if their
          populations or their broader communities are disabled or in some way
          compromised.
        </Typography>

        <Typography
          sx={{
            fontWeight: 300,
            fontSize: "16px",
            lineHeight: 1.2,
            marginBottom: "16px",
          }}
        >
          We cannot live in a natural world without knowledge and love of it.
          The natural beauty imbedded in ineffably complex living systems cannot
          by created by us. Indeed, we cannot create a single living thing. All
          we can do is come to know the living things and nurture their
          habitats. Imagine the epistemological challenge facing children who
          grow up in a world wholly and completely created by people, not any
          portion of which of which can replicate itself and make a new
          generation. Imagine the loss of humility, the cumulating hubris, the
          absence of genuine and awesome natural beauty in a diminished world in
          which the people have disenfranchised all other living things.
        </Typography>

        <Typography
          sx={{
            fontWeight: 300,
            fontSize: "16px",
            lineHeight: 1.2,
          }}
        >
          Organismal biological research is languishing within many contemporary
          university biology programs, as the lights of beauty and diversity
          wink out. The Conservation Research Institute is among the diminishing
          number of organizations devoted to the study of the harbingers of
          truth, the bearers of beauty, the living things that together in their
          fecundity and richness awe and humble us as their healthy presence
          nurtures our humanity.
        </Typography>
      </Box>
    </CriSection>
  );
};

export default OverviewSection;
